<!-- ── Level 2 sub-tabs ───────────────────────────────────────────────── -->
<div class="products-tab__subtabs">
  <div
    class="products-tab__subtab"
    role="tab"
    [attr.aria-selected]="activeL2Tab === 'external-references'"
    [class.active]="activeL2Tab === 'external-references'"
    (click)="onL2TabChange('external-references')"
  >
    {{ "knowledge_base.subtab.external_references" | translate }}
  </div>
  <div
    class="products-tab__subtab"
    role="tab"
    [attr.aria-selected]="activeL2Tab === 'aliases'"
    [class.active]="activeL2Tab === 'aliases'"
    (click)="onL2TabChange('aliases')"
  >
    {{ "knowledge_base.subtab.aliases" | translate }}
  </div>
  <div
    class="products-tab__subtab"
    role="tab"
    [attr.aria-selected]="activeL2Tab === 'ignore-list'"
    [class.active]="activeL2Tab === 'ignore-list'"
    (click)="onL2TabChange('ignore-list')"
  >
    {{ "knowledge_base.subtab.ignore_list" | translate }}
  </div>
  <div
    class="products-tab__subtab"
    role="tab"
    [attr.aria-selected]="activeL2Tab === 'preferred-products'"
    [class.active]="activeL2Tab === 'preferred-products'"
    (click)="onL2TabChange('preferred-products')"
  >
    {{ "knowledge_base.subtab.preferred_products" | translate }}
  </div>
</div>

<!-- ── Info banner ────────────────────────────────────────────────────── -->
<div class="products-tab__info-banner">
  <ui-svg-icon svgIcon="info" size="medium"></ui-svg-icon>
  <span *ngIf="activeL2Tab === 'external-references'">
    {{ "knowledge_base.info_banner.external_references" | translate }}
  </span>
  <span *ngIf="activeL2Tab === 'aliases'">
    {{ "knowledge_base.info_banner.aliases" | translate }}
  </span>
  <span *ngIf="activeL2Tab === 'ignore-list'">
    {{ "knowledge_base.info_banner.ignore_list" | translate }}
  </span>
  <span *ngIf="activeL2Tab === 'preferred-products'">
    {{ "knowledge_base.info_banner.preferred_products" | translate }}
  </span>
</div>

<!-- ── Sub-tab content ─────────────────────────────────────────────────── -->
<ng-container *ngIf="activeL2Tab === 'external-references'">
  <app-list-external-references></app-list-external-references>
</ng-container>
<ng-container *ngIf="activeL2Tab === 'aliases'">
  <app-list-aliases></app-list-aliases>
</ng-container>
<ng-container *ngIf="activeL2Tab === 'ignore-list'">
  <app-list-ignore-codes></app-list-ignore-codes>
</ng-container>
<ng-container *ngIf="activeL2Tab === 'preferred-products'">
  <app-list-preferred-products></app-list-preferred-products>
</ng-container>
